import React, { Component } from 'react';
import PropTypes from 'prop-types';

import GenericButton from '../../common/GenericButton';

export default class TitleValidationModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div ref={node => (this.titleValidationModal = node)}>
        <div className="row msg-box">
          <h6 className="custom-msg">
            {this.props.customMessage
              ? this.props.customMessage
              : 'You must enter a title to add an expression to.'}
          </h6>
        </div>
        <div className="row">
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto margin-bottom-10"
            onBtnClick={() => this.props.handleParentHide()}
          />
        </div>
      </div>
    );
  }
}
TitleValidationModal.propTypes = {
  handleParentHide: PropTypes.func,
  customMessage: PropTypes.string,
};
